"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: offer/offer-config.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Foffer%2Foffer-config.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.signupRewardCriteriaToJSON = exports.signupRewardCriteriaFromJSON = exports.offerTypeToJSON = exports.offerTypeFromJSON = exports.OfferEnrollmentGroupLimits = exports.OfferEnrollmentGroup = exports.SignupReward = exports.PerkRewardAction = exports.PerkReward = exports.FundingReward = exports.SpendingFractionReward = exports.MerchantNameAndCategory = exports.MerchantNameOrMerchantNameAndCategory = exports.MerchantNameOrCategory = exports.ManualReward = exports.Reward = exports.Eligibility = exports.OfferConfig = exports.SignupRewardCriteria = exports.OfferType = void 0;
const card_category_1 = require("../card/card-category");
const amount_1 = require("../common/amount");
const wallet_provider_1 = require("../common/wallet-provider");
const feature_1 = require("../feature/feature");
const tier_type_1 = require("../tier/tier-type");
const offer_content_1 = require("./offer-content");
const perk_partner_1 = require("./perk-partner");
const protobufPackage = 'com.step.offer.proto';
/**
 * Type of offers.
 */
var OfferType;
(function (OfferType) {
    OfferType["INVALID_SUB_TYPE"] = "INVALID_SUB_TYPE";
    OfferType["MERCHANT"] = "MERCHANT";
    OfferType["CATEGORY"] = "CATEGORY";
    OfferType["EVERYWHERE"] = "EVERYWHERE";
    OfferType["PERK"] = "PERK";
    OfferType["FUNDING"] = "FUNDING";
    OfferType["BUNDLE"] = "BUNDLE";
    OfferType["WALLET_PROVIDER"] = "WALLET_PROVIDER";
    OfferType["CASH_GIVEAWAY"] = "CASH_GIVEAWAY";
    OfferType["SIGNUP"] = "SIGNUP";
    OfferType["DIRECT_DEPOSIT"] = "DIRECT_DEPOSIT";
    OfferType["MANUAL"] = "MANUAL";
    OfferType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(OfferType || (exports.OfferType = OfferType = {}));
/**
 * Signup offer reward criteria
 */
var SignupRewardCriteria;
(function (SignupRewardCriteria) {
    SignupRewardCriteria["INVALID_SIGNUP_REWARD_CRITERIA"] = "INVALID_SIGNUP_REWARD_CRITERIA";
    /**
     * FAMILY_KYCED - If the user KYCs or is sponsored.
     */
    SignupRewardCriteria["FAMILY_KYCED"] = "FAMILY_KYCED";
    /**
     * ONBOARDED - If the user is onboarded (KYC = SKIPPED, SUCCESS, or PROCESSING)
     */
    SignupRewardCriteria["ONBOARDED"] = "ONBOARDED";
    /**
     * ACCOUNT_PROGRESS_COMPLETED - If the user has completed all Account Progress steps
     */
    SignupRewardCriteria["ACCOUNT_PROGRESS_COMPLETED"] = "ACCOUNT_PROGRESS_COMPLETED";
    SignupRewardCriteria["UNRECOGNIZED"] = "UNRECOGNIZED";
})(SignupRewardCriteria || (exports.SignupRewardCriteria = SignupRewardCriteria = {}));
function createBaseOfferConfig() {
    return {
        name: '',
        startsAtMs: '0',
        expiresAtMs: '0',
        code: '',
        eligibility: [],
        rewards: [],
        content: offer_content_1.OfferContent.fromPartial({}),
        enrollmentGroup: undefined,
        ordinal: 0,
        feature: feature_1.Feature.INVALID_FEATURE,
        featureNotEnabled: feature_1.Feature.INVALID_FEATURE,
        tiers: [],
        cardCategory: [],
        type: OfferType.INVALID_SUB_TYPE,
        autoEnroll: false,
    };
}
exports.OfferConfig = {
    fromJSON(object) {
        const message = {
            name: isSet(object.name) ? globalThis.String(object.name) : '',
            content: isSet(object.content)
                ? offer_content_1.OfferContent.fromJSON(object.content)
                : offer_content_1.OfferContent.fromPartial({}),
            feature: isSet(object.feature) ? (0, feature_1.featureFromJSON)(object.feature) : feature_1.Feature.INVALID_FEATURE,
            featureNotEnabled: isSet(object.featureNotEnabled)
                ? (0, feature_1.featureFromJSON)(object.featureNotEnabled)
                : feature_1.Feature.INVALID_FEATURE,
            type: isSet(object.type) ? offerTypeFromJSON(object.type) : OfferType.INVALID_SUB_TYPE,
        };
        if (isSet(object.startsAtMs)) {
            message.startsAtMs = globalThis.String(object.startsAtMs);
        }
        if (isSet(object.expiresAtMs)) {
            message.expiresAtMs = globalThis.String(object.expiresAtMs);
        }
        if (isSet(object.code)) {
            message.code = globalThis.String(object.code);
        }
        if (globalThis.Array.isArray(object?.eligibility)) {
            message.eligibility = object.eligibility.map((e) => exports.Eligibility.fromJSON(e));
        }
        if (globalThis.Array.isArray(object?.rewards)) {
            message.rewards = object.rewards.map((e) => exports.Reward.fromJSON(e));
        }
        if (isSet(object.enrollmentGroup)) {
            message.enrollmentGroup = exports.OfferEnrollmentGroup.fromJSON(object.enrollmentGroup);
        }
        if (isSet(object.ordinal)) {
            message.ordinal = globalThis.Number(object.ordinal);
        }
        if (globalThis.Array.isArray(object?.tiers)) {
            message.tiers = object.tiers.map((e) => (0, tier_type_1.tierTypeFromJSON)(e));
        }
        if (globalThis.Array.isArray(object?.cardCategory)) {
            message.cardCategory = object.cardCategory.map((e) => (0, card_category_1.cardCategoryFromJSON)(e));
        }
        if (isSet(object.autoEnroll)) {
            message.autoEnroll = globalThis.Boolean(object.autoEnroll);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== '') {
            obj.name = message.name;
        }
        if (message.startsAtMs !== undefined && message.startsAtMs !== '0') {
            obj.startsAtMs = message.startsAtMs;
        }
        if (message.expiresAtMs !== undefined && message.expiresAtMs !== '0') {
            obj.expiresAtMs = message.expiresAtMs;
        }
        if (message.code !== undefined && message.code !== '') {
            obj.code = message.code;
        }
        if (message.eligibility?.length) {
            obj.eligibility = message.eligibility.map((e) => exports.Eligibility.toJSON(e));
        }
        if (message.rewards?.length) {
            obj.rewards = message.rewards.map((e) => exports.Reward.toJSON(e));
        }
        if (message.content !== undefined) {
            obj.content = offer_content_1.OfferContent.toJSON(message.content);
        }
        if (message.enrollmentGroup !== undefined) {
            obj.enrollmentGroup = exports.OfferEnrollmentGroup.toJSON(message.enrollmentGroup);
        }
        if (message.ordinal !== undefined && message.ordinal !== 0) {
            obj.ordinal = Math.round(message.ordinal);
        }
        if (message.feature !== feature_1.Feature.INVALID_FEATURE) {
            obj.feature = (0, feature_1.featureToJSON)(message.feature);
        }
        if (message.featureNotEnabled !== feature_1.Feature.INVALID_FEATURE) {
            obj.featureNotEnabled = (0, feature_1.featureToJSON)(message.featureNotEnabled);
        }
        if (message.tiers?.length) {
            obj.tiers = message.tiers.map((e) => (0, tier_type_1.tierTypeToJSON)(e));
        }
        if (message.cardCategory?.length) {
            obj.cardCategory = message.cardCategory.map((e) => (0, card_category_1.cardCategoryToJSON)(e));
        }
        if (message.type !== OfferType.INVALID_SUB_TYPE) {
            obj.type = offerTypeToJSON(message.type);
        }
        if (message.autoEnroll !== undefined && message.autoEnroll !== false) {
            obj.autoEnroll = message.autoEnroll;
        }
        return obj;
    },
    create(base) {
        return exports.OfferConfig.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOfferConfig();
        message.name = object.name ?? '';
        message.startsAtMs = object.startsAtMs ?? '0';
        message.expiresAtMs = object.expiresAtMs ?? '0';
        message.code = object.code ?? '';
        message.eligibility = object.eligibility?.map((e) => exports.Eligibility.fromPartial(e)) || [];
        message.rewards = object.rewards?.map((e) => exports.Reward.fromPartial(e)) || [];
        message.content = (object.content !== undefined && object.content !== null)
            ? offer_content_1.OfferContent.fromPartial(object.content)
            : offer_content_1.OfferContent.fromPartial({});
        message.enrollmentGroup =
            (object.enrollmentGroup !== undefined && object.enrollmentGroup !== null)
                ? exports.OfferEnrollmentGroup.fromPartial(object.enrollmentGroup)
                : undefined;
        message.ordinal = object.ordinal ?? 0;
        message.feature = object.feature ?? feature_1.Feature.INVALID_FEATURE;
        message.featureNotEnabled = object.featureNotEnabled ?? feature_1.Feature.INVALID_FEATURE;
        message.tiers = object.tiers?.map((e) => e) || [];
        message.cardCategory = object.cardCategory?.map((e) => e) || [];
        message.type = object.type ?? OfferType.INVALID_SUB_TYPE;
        message.autoEnroll = object.autoEnroll ?? false;
        return message;
    },
};
function createBaseEligibility() {
    return { maxAccountAgeDays: undefined };
}
exports.Eligibility = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.maxAccountAgeDays)) {
            message.maxAccountAgeDays = globalThis.Number(object.maxAccountAgeDays);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.maxAccountAgeDays !== undefined) {
            obj.maxAccountAgeDays = Math.round(message.maxAccountAgeDays);
        }
        return obj;
    },
    create(base) {
        return exports.Eligibility.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEligibility();
        message.maxAccountAgeDays = object.maxAccountAgeDays ?? undefined;
        return message;
    },
};
function createBaseReward() {
    return {
        id: '',
        maxPayoutCount: 0,
        maxTotalPayout: 0,
        maxTotalPayoutMonthly: 0,
        maxTotalPayoutAnnually: 0,
        maxPayoutPerPayment: 0,
        spendingFraction: undefined,
        manual: undefined,
        funding: undefined,
        perk: undefined,
        signup: undefined,
        rewardType: '',
    };
}
exports.Reward = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            rewardType: isSet(object.rewardType) ? globalThis.String(object.rewardType) : '',
        };
        if (isSet(object.maxPayoutCount)) {
            message.maxPayoutCount = globalThis.Number(object.maxPayoutCount);
        }
        if (isSet(object.maxTotalPayout)) {
            message.maxTotalPayout = globalThis.Number(object.maxTotalPayout);
        }
        if (isSet(object.maxTotalPayoutMonthly)) {
            message.maxTotalPayoutMonthly = globalThis.Number(object.maxTotalPayoutMonthly);
        }
        if (isSet(object.maxTotalPayoutAnnually)) {
            message.maxTotalPayoutAnnually = globalThis.Number(object.maxTotalPayoutAnnually);
        }
        if (isSet(object.maxPayoutPerPayment)) {
            message.maxPayoutPerPayment = globalThis.Number(object.maxPayoutPerPayment);
        }
        if (isSet(object.spendingFraction)) {
            message.spendingFraction = exports.SpendingFractionReward.fromJSON(object.spendingFraction);
        }
        if (isSet(object.manual)) {
            message.manual = exports.ManualReward.fromJSON(object.manual);
        }
        if (isSet(object.funding)) {
            message.funding = exports.FundingReward.fromJSON(object.funding);
        }
        if (isSet(object.perk)) {
            message.perk = exports.PerkReward.fromJSON(object.perk);
        }
        if (isSet(object.signup)) {
            message.signup = exports.SignupReward.fromJSON(object.signup);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.maxPayoutCount !== undefined && message.maxPayoutCount !== 0) {
            obj.maxPayoutCount = Math.round(message.maxPayoutCount);
        }
        if (message.maxTotalPayout !== undefined && message.maxTotalPayout !== 0) {
            obj.maxTotalPayout = message.maxTotalPayout;
        }
        if (message.maxTotalPayoutMonthly !== undefined && message.maxTotalPayoutMonthly !== 0) {
            obj.maxTotalPayoutMonthly = message.maxTotalPayoutMonthly;
        }
        if (message.maxTotalPayoutAnnually !== undefined && message.maxTotalPayoutAnnually !== 0) {
            obj.maxTotalPayoutAnnually = message.maxTotalPayoutAnnually;
        }
        if (message.maxPayoutPerPayment !== undefined && message.maxPayoutPerPayment !== 0) {
            obj.maxPayoutPerPayment = message.maxPayoutPerPayment;
        }
        if (message.spendingFraction !== undefined) {
            obj.spendingFraction = exports.SpendingFractionReward.toJSON(message.spendingFraction);
        }
        if (message.manual !== undefined) {
            obj.manual = exports.ManualReward.toJSON(message.manual);
        }
        if (message.funding !== undefined) {
            obj.funding = exports.FundingReward.toJSON(message.funding);
        }
        if (message.perk !== undefined) {
            obj.perk = exports.PerkReward.toJSON(message.perk);
        }
        if (message.signup !== undefined) {
            obj.signup = exports.SignupReward.toJSON(message.signup);
        }
        if (message.rewardType !== '') {
            obj.rewardType = message.rewardType;
        }
        return obj;
    },
    create(base) {
        return exports.Reward.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReward();
        message.id = object.id ?? '';
        message.maxPayoutCount = object.maxPayoutCount ?? 0;
        message.maxTotalPayout = object.maxTotalPayout ?? 0;
        message.maxTotalPayoutMonthly = object.maxTotalPayoutMonthly ?? 0;
        message.maxTotalPayoutAnnually = object.maxTotalPayoutAnnually ?? 0;
        message.maxPayoutPerPayment = object.maxPayoutPerPayment ?? 0;
        message.spendingFraction =
            (object.spendingFraction !== undefined && object.spendingFraction !== null)
                ? exports.SpendingFractionReward.fromPartial(object.spendingFraction)
                : undefined;
        message.manual = (object.manual !== undefined && object.manual !== null)
            ? exports.ManualReward.fromPartial(object.manual)
            : undefined;
        message.funding = (object.funding !== undefined && object.funding !== null)
            ? exports.FundingReward.fromPartial(object.funding)
            : undefined;
        message.perk = (object.perk !== undefined && object.perk !== null)
            ? exports.PerkReward.fromPartial(object.perk)
            : undefined;
        message.signup = (object.signup !== undefined && object.signup !== null)
            ? exports.SignupReward.fromPartial(object.signup)
            : undefined;
        message.rewardType = object.rewardType ?? '';
        return message;
    },
};
function createBaseManualReward() {
    return {};
}
exports.ManualReward = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ManualReward.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseManualReward();
        return message;
    },
};
function createBaseMerchantNameOrCategory() {
    return { merchantNameContains: [], merchantCategory: [] };
}
exports.MerchantNameOrCategory = {
    fromJSON(object) {
        const message = {};
        if (globalThis.Array.isArray(object?.merchantNameContains)) {
            message.merchantNameContains = object.merchantNameContains.map((e) => globalThis.String(e));
        }
        if (globalThis.Array.isArray(object?.merchantCategory)) {
            message.merchantCategory = object.merchantCategory.map((e) => globalThis.String(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchantNameContains?.length) {
            obj.merchantNameContains = message.merchantNameContains;
        }
        if (message.merchantCategory?.length) {
            obj.merchantCategory = message.merchantCategory;
        }
        return obj;
    },
    create(base) {
        return exports.MerchantNameOrCategory.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMerchantNameOrCategory();
        message.merchantNameContains = object.merchantNameContains?.map((e) => e) || [];
        message.merchantCategory = object.merchantCategory?.map((e) => e) || [];
        return message;
    },
};
function createBaseMerchantNameOrMerchantNameAndCategory() {
    return { merchantNameContains: [], merchantNameAndCategory: undefined };
}
exports.MerchantNameOrMerchantNameAndCategory = {
    fromJSON(object) {
        const message = {};
        if (globalThis.Array.isArray(object?.merchantNameContains)) {
            message.merchantNameContains = object.merchantNameContains.map((e) => globalThis.String(e));
        }
        if (isSet(object.merchantNameAndCategory)) {
            message.merchantNameAndCategory = exports.MerchantNameAndCategory.fromJSON(object.merchantNameAndCategory);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchantNameContains?.length) {
            obj.merchantNameContains = message.merchantNameContains;
        }
        if (message.merchantNameAndCategory !== undefined) {
            obj.merchantNameAndCategory = exports.MerchantNameAndCategory.toJSON(message.merchantNameAndCategory);
        }
        return obj;
    },
    create(base) {
        return exports.MerchantNameOrMerchantNameAndCategory.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMerchantNameOrMerchantNameAndCategory();
        message.merchantNameContains = object.merchantNameContains?.map((e) => e) || [];
        message.merchantNameAndCategory =
            (object.merchantNameAndCategory !== undefined && object.merchantNameAndCategory !== null)
                ? exports.MerchantNameAndCategory.fromPartial(object.merchantNameAndCategory)
                : undefined;
        return message;
    },
};
function createBaseMerchantNameAndCategory() {
    return { merchantNameContains: [], merchantCategory: [] };
}
exports.MerchantNameAndCategory = {
    fromJSON(object) {
        const message = {};
        if (globalThis.Array.isArray(object?.merchantNameContains)) {
            message.merchantNameContains = object.merchantNameContains.map((e) => globalThis.String(e));
        }
        if (globalThis.Array.isArray(object?.merchantCategory)) {
            message.merchantCategory = object.merchantCategory.map((e) => globalThis.String(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchantNameContains?.length) {
            obj.merchantNameContains = message.merchantNameContains;
        }
        if (message.merchantCategory?.length) {
            obj.merchantCategory = message.merchantCategory;
        }
        return obj;
    },
    create(base) {
        return exports.MerchantNameAndCategory.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMerchantNameAndCategory();
        message.merchantNameContains = object.merchantNameContains?.map((e) => e) || [];
        message.merchantCategory = object.merchantCategory?.map((e) => e) || [];
        return message;
    },
};
function createBaseSpendingFractionReward() {
    return {
        fraction: 0,
        minTransactionAmount: 0,
        merchantNameContains: [],
        merchantNetworkId: [],
        walletProviders: [],
        merchantCategory: [],
        merchantNameOrCategory: undefined,
        merchantNameOrMerchantNameAndCategory: undefined,
        merchantNameIgnores: [],
        minPaymentAmount: 0,
        merchantNameAndCategory: undefined,
    };
}
exports.SpendingFractionReward = {
    fromJSON(object) {
        const message = {
            fraction: isSet(object.fraction) ? globalThis.Number(object.fraction) : 0,
        };
        if (isSet(object.minTransactionAmount)) {
            message.minTransactionAmount = globalThis.Number(object.minTransactionAmount);
        }
        if (globalThis.Array.isArray(object?.merchantNameContains)) {
            message.merchantNameContains = object.merchantNameContains.map((e) => globalThis.String(e));
        }
        if (globalThis.Array.isArray(object?.merchantNetworkId)) {
            message.merchantNetworkId = object.merchantNetworkId.map((e) => globalThis.String(e));
        }
        if (globalThis.Array.isArray(object?.walletProviders)) {
            message.walletProviders = object.walletProviders.map((e) => (0, wallet_provider_1.walletProviderFromJSON)(e));
        }
        if (globalThis.Array.isArray(object?.merchantCategory)) {
            message.merchantCategory = object.merchantCategory.map((e) => globalThis.String(e));
        }
        if (isSet(object.merchantNameOrCategory)) {
            message.merchantNameOrCategory = exports.MerchantNameOrCategory.fromJSON(object.merchantNameOrCategory);
        }
        if (isSet(object.merchantNameOrMerchantNameAndCategory)) {
            message.merchantNameOrMerchantNameAndCategory = exports.MerchantNameOrMerchantNameAndCategory
                .fromJSON(object.merchantNameOrMerchantNameAndCategory);
        }
        if (globalThis.Array.isArray(object?.merchantNameIgnores)) {
            message.merchantNameIgnores = object.merchantNameIgnores.map((e) => globalThis.String(e));
        }
        if (isSet(object.minPaymentAmount)) {
            message.minPaymentAmount = globalThis.Number(object.minPaymentAmount);
        }
        if (isSet(object.merchantNameAndCategory)) {
            message.merchantNameAndCategory = exports.MerchantNameAndCategory.fromJSON(object.merchantNameAndCategory);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.fraction !== 0) {
            obj.fraction = message.fraction;
        }
        if (message.minTransactionAmount !== undefined && message.minTransactionAmount !== 0) {
            obj.minTransactionAmount = message.minTransactionAmount;
        }
        if (message.merchantNameContains?.length) {
            obj.merchantNameContains = message.merchantNameContains;
        }
        if (message.merchantNetworkId?.length) {
            obj.merchantNetworkId = message.merchantNetworkId;
        }
        if (message.walletProviders?.length) {
            obj.walletProviders = message.walletProviders.map((e) => (0, wallet_provider_1.walletProviderToJSON)(e));
        }
        if (message.merchantCategory?.length) {
            obj.merchantCategory = message.merchantCategory;
        }
        if (message.merchantNameOrCategory !== undefined) {
            obj.merchantNameOrCategory = exports.MerchantNameOrCategory.toJSON(message.merchantNameOrCategory);
        }
        if (message.merchantNameOrMerchantNameAndCategory !== undefined) {
            obj.merchantNameOrMerchantNameAndCategory = exports.MerchantNameOrMerchantNameAndCategory.toJSON(message.merchantNameOrMerchantNameAndCategory);
        }
        if (message.merchantNameIgnores?.length) {
            obj.merchantNameIgnores = message.merchantNameIgnores;
        }
        if (message.minPaymentAmount !== undefined && message.minPaymentAmount !== 0) {
            obj.minPaymentAmount = message.minPaymentAmount;
        }
        if (message.merchantNameAndCategory !== undefined) {
            obj.merchantNameAndCategory = exports.MerchantNameAndCategory.toJSON(message.merchantNameAndCategory);
        }
        return obj;
    },
    create(base) {
        return exports.SpendingFractionReward.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSpendingFractionReward();
        message.fraction = object.fraction ?? 0;
        message.minTransactionAmount = object.minTransactionAmount ?? 0;
        message.merchantNameContains = object.merchantNameContains?.map((e) => e) || [];
        message.merchantNetworkId = object.merchantNetworkId?.map((e) => e) || [];
        message.walletProviders = object.walletProviders?.map((e) => e) || [];
        message.merchantCategory = object.merchantCategory?.map((e) => e) || [];
        message.merchantNameOrCategory =
            (object.merchantNameOrCategory !== undefined && object.merchantNameOrCategory !== null)
                ? exports.MerchantNameOrCategory.fromPartial(object.merchantNameOrCategory)
                : undefined;
        message.merchantNameOrMerchantNameAndCategory =
            (object.merchantNameOrMerchantNameAndCategory !== undefined &&
                object.merchantNameOrMerchantNameAndCategory !== null)
                ? exports.MerchantNameOrMerchantNameAndCategory.fromPartial(object.merchantNameOrMerchantNameAndCategory)
                : undefined;
        message.merchantNameIgnores = object.merchantNameIgnores?.map((e) => e) || [];
        message.minPaymentAmount = object.minPaymentAmount ?? 0;
        message.merchantNameAndCategory =
            (object.merchantNameAndCategory !== undefined && object.merchantNameAndCategory !== null)
                ? exports.MerchantNameAndCategory.fromPartial(object.merchantNameAndCategory)
                : undefined;
        return message;
    },
};
function createBaseFundingReward() {
    return { minFundingAmount: 0, rewardAmount: 0 };
}
exports.FundingReward = {
    fromJSON(object) {
        const message = {
            rewardAmount: isSet(object.rewardAmount) ? globalThis.Number(object.rewardAmount) : 0,
        };
        if (isSet(object.minFundingAmount)) {
            message.minFundingAmount = globalThis.Number(object.minFundingAmount);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.minFundingAmount !== undefined && message.minFundingAmount !== 0) {
            obj.minFundingAmount = message.minFundingAmount;
        }
        if (message.rewardAmount !== 0) {
            obj.rewardAmount = message.rewardAmount;
        }
        return obj;
    },
    create(base) {
        return exports.FundingReward.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFundingReward();
        message.minFundingAmount = object.minFundingAmount ?? 0;
        message.rewardAmount = object.rewardAmount ?? 0;
        return message;
    },
};
function createBasePerkReward() {
    return {
        partner: perk_partner_1.PerkPartner.INVALID_PERK_PARTNER,
        promoCode: '',
        action: undefined,
        rewardStatus: undefined,
    };
}
exports.PerkReward = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.partner)) {
            message.partner = (0, perk_partner_1.perkPartnerFromJSON)(object.partner);
        }
        if (isSet(object.promoCode)) {
            message.promoCode = globalThis.String(object.promoCode);
        }
        if (isSet(object.action)) {
            message.action = exports.PerkRewardAction.fromJSON(object.action);
        }
        if (isSet(object.rewardStatus)) {
            message.rewardStatus = globalThis.String(object.rewardStatus);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.partner !== undefined && message.partner !== perk_partner_1.PerkPartner.INVALID_PERK_PARTNER) {
            obj.partner = (0, perk_partner_1.perkPartnerToJSON)(message.partner);
        }
        if (message.promoCode !== undefined && message.promoCode !== '') {
            obj.promoCode = message.promoCode;
        }
        if (message.action !== undefined) {
            obj.action = exports.PerkRewardAction.toJSON(message.action);
        }
        if (message.rewardStatus !== undefined) {
            obj.rewardStatus = message.rewardStatus;
        }
        return obj;
    },
    create(base) {
        return exports.PerkReward.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePerkReward();
        message.partner = object.partner ?? perk_partner_1.PerkPartner.INVALID_PERK_PARTNER;
        message.promoCode = object.promoCode ?? '';
        message.action = (object.action !== undefined && object.action !== null)
            ? exports.PerkRewardAction.fromPartial(object.action)
            : undefined;
        message.rewardStatus = object.rewardStatus ?? undefined;
        return message;
    },
};
function createBasePerkRewardAction() {
    return { url: '', title: '', notice: '' };
}
exports.PerkRewardAction = {
    fromJSON(object) {
        const message = {
            url: isSet(object.url) ? globalThis.String(object.url) : '',
            notice: isSet(object.notice) ? globalThis.String(object.notice) : '',
        };
        if (isSet(object.title)) {
            message.title = globalThis.String(object.title);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.url !== '') {
            obj.url = message.url;
        }
        if (message.title !== undefined && message.title !== '') {
            obj.title = message.title;
        }
        if (message.notice !== '') {
            obj.notice = message.notice;
        }
        return obj;
    },
    create(base) {
        return exports.PerkRewardAction.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePerkRewardAction();
        message.url = object.url ?? '';
        message.title = object.title ?? '';
        message.notice = object.notice ?? '';
        return message;
    },
};
function createBaseSignupReward() {
    return {
        criteria: SignupRewardCriteria.INVALID_SIGNUP_REWARD_CRITERIA,
        rewardAmount: amount_1.Amount.fromPartial({}),
    };
}
exports.SignupReward = {
    fromJSON(object) {
        const message = {
            criteria: isSet(object.criteria)
                ? signupRewardCriteriaFromJSON(object.criteria)
                : SignupRewardCriteria.INVALID_SIGNUP_REWARD_CRITERIA,
            rewardAmount: isSet(object.rewardAmount)
                ? amount_1.Amount.fromJSON(object.rewardAmount)
                : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.criteria !== SignupRewardCriteria.INVALID_SIGNUP_REWARD_CRITERIA) {
            obj.criteria = signupRewardCriteriaToJSON(message.criteria);
        }
        if (message.rewardAmount !== undefined) {
            obj.rewardAmount = amount_1.Amount.toJSON(message.rewardAmount);
        }
        return obj;
    },
    create(base) {
        return exports.SignupReward.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSignupReward();
        message.criteria = object.criteria ?? SignupRewardCriteria.INVALID_SIGNUP_REWARD_CRITERIA;
        message.rewardAmount = (object.rewardAmount !== undefined && object.rewardAmount !== null)
            ? amount_1.Amount.fromPartial(object.rewardAmount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseOfferEnrollmentGroup() {
    return { groupId: '', isInternal: false, limits: undefined };
}
exports.OfferEnrollmentGroup = {
    fromJSON(object) {
        const message = {
            groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : '',
            isInternal: isSet(object.isInternal) ? globalThis.Boolean(object.isInternal) : false,
        };
        if (isSet(object.limits)) {
            message.limits = exports.OfferEnrollmentGroupLimits.fromJSON(object.limits);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.groupId !== '') {
            obj.groupId = message.groupId;
        }
        if (message.isInternal !== false) {
            obj.isInternal = message.isInternal;
        }
        if (message.limits !== undefined) {
            obj.limits = exports.OfferEnrollmentGroupLimits.toJSON(message.limits);
        }
        return obj;
    },
    create(base) {
        return exports.OfferEnrollmentGroup.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOfferEnrollmentGroup();
        message.groupId = object.groupId ?? '';
        message.isInternal = object.isInternal ?? false;
        message.limits = (object.limits !== undefined && object.limits !== null)
            ? exports.OfferEnrollmentGroupLimits.fromPartial(object.limits)
            : undefined;
        return message;
    },
};
function createBaseOfferEnrollmentGroupLimits() {
    return { maxEnrollments: 0, isAtEnrollmentLimit: false };
}
exports.OfferEnrollmentGroupLimits = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.maxEnrollments)) {
            message.maxEnrollments = globalThis.Number(object.maxEnrollments);
        }
        if (isSet(object.isAtEnrollmentLimit)) {
            message.isAtEnrollmentLimit = globalThis.Boolean(object.isAtEnrollmentLimit);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.maxEnrollments !== undefined && message.maxEnrollments !== 0) {
            obj.maxEnrollments = Math.round(message.maxEnrollments);
        }
        if (message.isAtEnrollmentLimit !== undefined && message.isAtEnrollmentLimit !== false) {
            obj.isAtEnrollmentLimit = message.isAtEnrollmentLimit;
        }
        return obj;
    },
    create(base) {
        return exports.OfferEnrollmentGroupLimits.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOfferEnrollmentGroupLimits();
        message.maxEnrollments = object.maxEnrollments ?? 0;
        message.isAtEnrollmentLimit = object.isAtEnrollmentLimit ?? false;
        return message;
    },
};
function offerTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_SUB_TYPE':
            return OfferType.INVALID_SUB_TYPE;
        case 1:
        case 'MERCHANT':
            return OfferType.MERCHANT;
        case 2:
        case 'CATEGORY':
            return OfferType.CATEGORY;
        case 3:
        case 'EVERYWHERE':
            return OfferType.EVERYWHERE;
        case 4:
        case 'PERK':
            return OfferType.PERK;
        case 6:
        case 'FUNDING':
            return OfferType.FUNDING;
        case 7:
        case 'BUNDLE':
            return OfferType.BUNDLE;
        case 8:
        case 'WALLET_PROVIDER':
            return OfferType.WALLET_PROVIDER;
        case 10:
        case 'CASH_GIVEAWAY':
            return OfferType.CASH_GIVEAWAY;
        case 11:
        case 'SIGNUP':
            return OfferType.SIGNUP;
        case 12:
        case 'DIRECT_DEPOSIT':
            return OfferType.DIRECT_DEPOSIT;
        case 13:
        case 'MANUAL':
            return OfferType.MANUAL;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return OfferType.UNRECOGNIZED;
    }
}
exports.offerTypeFromJSON = offerTypeFromJSON;
function offerTypeToJSON(object) {
    switch (object) {
        case OfferType.INVALID_SUB_TYPE:
            return 'INVALID_SUB_TYPE';
        case OfferType.MERCHANT:
            return 'MERCHANT';
        case OfferType.CATEGORY:
            return 'CATEGORY';
        case OfferType.EVERYWHERE:
            return 'EVERYWHERE';
        case OfferType.PERK:
            return 'PERK';
        case OfferType.FUNDING:
            return 'FUNDING';
        case OfferType.BUNDLE:
            return 'BUNDLE';
        case OfferType.WALLET_PROVIDER:
            return 'WALLET_PROVIDER';
        case OfferType.CASH_GIVEAWAY:
            return 'CASH_GIVEAWAY';
        case OfferType.SIGNUP:
            return 'SIGNUP';
        case OfferType.DIRECT_DEPOSIT:
            return 'DIRECT_DEPOSIT';
        case OfferType.MANUAL:
            return 'MANUAL';
        case OfferType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.offerTypeToJSON = offerTypeToJSON;
function signupRewardCriteriaFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_SIGNUP_REWARD_CRITERIA':
            return SignupRewardCriteria.INVALID_SIGNUP_REWARD_CRITERIA;
        case 1:
        case 'FAMILY_KYCED':
            return SignupRewardCriteria.FAMILY_KYCED;
        case 2:
        case 'ONBOARDED':
            return SignupRewardCriteria.ONBOARDED;
        case 3:
        case 'ACCOUNT_PROGRESS_COMPLETED':
            return SignupRewardCriteria.ACCOUNT_PROGRESS_COMPLETED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return SignupRewardCriteria.UNRECOGNIZED;
    }
}
exports.signupRewardCriteriaFromJSON = signupRewardCriteriaFromJSON;
function signupRewardCriteriaToJSON(object) {
    switch (object) {
        case SignupRewardCriteria.INVALID_SIGNUP_REWARD_CRITERIA:
            return 'INVALID_SIGNUP_REWARD_CRITERIA';
        case SignupRewardCriteria.FAMILY_KYCED:
            return 'FAMILY_KYCED';
        case SignupRewardCriteria.ONBOARDED:
            return 'ONBOARDED';
        case SignupRewardCriteria.ACCOUNT_PROGRESS_COMPLETED:
            return 'ACCOUNT_PROGRESS_COMPLETED';
        case SignupRewardCriteria.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.signupRewardCriteriaToJSON = signupRewardCriteriaToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=offer-config.js.map